module.exports = {
      id: "android-block-usage",
      viewBox: "0 0 114 35",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#android-block",
      toString: function () {
        return this.url;
      }
    }